import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgArrowLeft = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 12,
	height: 21,
	viewBox: "0 0 12 21",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M10.0279 20.0554L0 10.0275L10.0279 0L12 1.97208L3.94458 10.0275L12 18.0833L10.0279 20.0554Z",
		fill: "#1C1B1F"
	})
});
export default SvgArrowLeft;
